import { Reducer } from 'redux';
import { IConflictHistoryState } from './types';
import { StudentActionTypes } from '../types';

const initialState: IConflictHistoryState = {};

const reducer: Reducer<IConflictHistoryState> = (state = initialState, action): IConflictHistoryState => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...initialState,
        ...action.payload.student.conflictHistory,
      };
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS: {
      if (action.payload.conflictHistory) {
        return {
          ...initialState,
          ...action.payload.conflictHistory,
        };
      }
      return state;
    }
    default:
      return state;
  }
};

export { reducer as conflictHistoryReducer };
